/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,TabViewModule,PanelModule,OverlayPanelModule,ButtonModule, CalendarModule, TreeModule,InputTextModule,InputTextareaModule,CheckboxModule, DropdownModule} from 'primeng/primeng';
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {HttpModule} from "@angular/http";
import { ExDialogModule } from  '../../component/dialog.component';
import {BrowserModule} from "@angular/platform-browser";
import {MamAdminService} from '../../service/mam_service.component';
import { PolicySchedule } from '../../model/policyControlSchedule';
import {Calendar} from "primeng/components/calendar/calendar";
import {SelectItem} from "primeng/components/common/api";
import { MdmPolicy } from '../../model/mdmpolicy';
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS

@Component({
  selector: 'policy-schedule',
  templateUrl: 'policy_schedule.html'
})
export class PolicyScheduleComponent implements OnInit {
  private policySchedule_list : PolicySchedule[] = [];
  private policy_list : MdmPolicy[] = [];
  selectedPolicy : MdmPolicy;

  addForm : FormGroup;
  addShow : boolean;
  dialogWidth : any = 600;

  policy_items : SelectItem[] = [];
  excute_time_item : SelectItem[] = [];
  select_time : string;

  ngOnInit() {
    this.logger.debug("----------------");
    var i = 0;
    for( i = 0 ; i < 24 ; i++) {
      this.logger.debug("----------------");
      this.excute_time_item.push({label: i+1 + " 시", value: String(i+1)});
    }


    this.logger.debug(this.excute_time_item.length);
    //this.select_time = this.excute_time_item[0];
    this.getPolicySchedule(1,10,'','','');

    // 일반정책 가져오기
    this.getPolicy(0);
  }

  constructor(private service:MamAdminService, private fb: FormBuilder, private logger : Logger) {




    this.addForm = this.fb.group({
      'name' : new FormControl('',Validators.required),
      'excuteDay' : new FormControl('',Validators.required),
      'excuteTime' : new FormControl('',Validators.required),
      'createTime' : new FormControl('', Validators.required),
      'policy' : new FormControl('', Validators.required)
    });
  }

  // ----------------- service --------------------------------------------
  getPolicySchedule(page:number, max:number, search:string, like:string, field:string) {
    this.service.getPolicySchedule(page, max, search, like, field).subscribe(
        value => {
          this.policySchedule_list = value.rows;
          this.logger.debug("-- policySchedule_list :", value);
        },
        error => { this.logger.error("-- error : " + error);  },
        () => { }
      )
  }

  getPolicy(type:number) {
    this.service.getPolicyAll().subscribe(
        value => {
          this.policy_list = value;
          this.logger.debug(this.policy_list.length);
          this.logger.debug("-- policy_list :", value);
        },
        error => { this.logger.error("-- error : " + error);  },
        () => { }
      )
  }
  //----------------------------event --------------------------------------
  addClick() {
    this.addShow = true;
    if(this.policy_list.length > 0) {
      this.selectedPolicy = this.policy_list[0];
    }
    this.logger.debug(this.policy_items);
    this.policy_list.forEach(value => {

      this.policy_items.push({label:value.name ,value: value});
    })
  }

  delClick() {

  }

  onSubmit(data) {
    this.logger.debug("submit data : ",  data);
  }

  onTimeChange(event) {
    this.logger.debug("onTimeChange data : ",  event);
  }

  onPolicyChange(event) {
    this.logger.debug("onPolicyChange data : ",  event);
  }

  get diagnostic() { return JSON.stringify(this.addForm.value);}
}


@NgModule({
  imports: [DropdownModule, ExDialogModule, CalendarModule, ReactiveFormsModule, DataTableModule,TabViewModule,PanelModule,OverlayPanelModule,ButtonModule, TreeModule,InputTextModule,InputTextareaModule,CheckboxModule,RouterModule,HttpModule,FormsModule,BrowserModule],
  exports: [PolicyScheduleComponent],
  declarations: [PolicyScheduleComponent],
  providers: [],
})
export class PolicyScheduleModule {
}



// WEBPACK FOOTER //
// ./src/app/page/policy/policy_schedule.ts